import React from "react";
import { BadgeIcon, DotIcon, PersonCheckIcon } from "./icons";
import "../App.css";

const STATS = [
  { icon: <BadgeIcon />, value: "100%", label: "Conformidade Fiscal" },
  { icon: <DotIcon />, value: "Visão", label: "Estratégica" },
  { icon: <PersonCheckIcon />, value: "Atendimento", label: "Consultivo" },
];

export default function Differentials() {
  return (
    <section className="differentials">
      <div className="differentials__container">
        <span className="differentials__eyebrow">Nossos Diferenciais</span>
        <h2 className="differentials__title">Por que escolher a Eniato Contabilidade?</h2>

        <div className="differentials__grid">
          {STATS.map((stat) => (
            <div key={stat.label} className="differentials__item">
              <div className="differentials__icon" aria-hidden="true">
                {stat.icon}
              </div>
              <span className="differentials__value">{stat.value}</span>
              <span className="differentials__label">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
